import { tv } from './chunk-7NOFBOMW.js';
import { cn } from './chunk-UYYBXMNI.js';
import * as LabelPrimitive from '@radix-ui/react-label';
import { Slot } from '@radix-ui/react-slot';
import * as React2 from 'react';
import { useFormContext, FormProvider, Controller } from 'react-hook-form';
import { jsx } from 'react/jsx-runtime';

var labelVariants = tv({
  base: "text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
});
var Label = React2.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(LabelPrimitive.Root, { ref, className: cn(labelVariants(), className), ...props }));
Label.displayName = LabelPrimitive.Root.displayName;
var FormItemContext = React2.createContext({});
var FormFieldContext = React2.createContext({});
var useFormField = () => {
  const fieldContext = React2.useContext(FormFieldContext);
  const itemContext = React2.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();
  const fieldState = getFieldState(fieldContext.name, formState);
  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>");
  }
  const { id } = itemContext;
  return {
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState
  };
};
var Form = FormProvider;
var FormField = ({
  ...props
}) => {
  return /* @__PURE__ */ jsx(FormFieldContext.Provider, { value: { name: props.name }, children: /* @__PURE__ */ jsx(Controller, { ...props }) });
};
var FormItem = React2.forwardRef(
  ({ className, ...props }, ref) => {
    const id = React2.useId();
    return /* @__PURE__ */ jsx(FormItemContext.Provider, { value: { id }, children: /* @__PURE__ */ jsx("div", { ref, className: cn("space-y-1.5", className), ...props }) });
  }
);
FormItem.displayName = "FormItem";
var FormLabel = React2.forwardRef(({ className, ...props }, ref) => {
  const { formItemId } = useFormField();
  return /* @__PURE__ */ jsx(Label, { ref, className, htmlFor: formItemId, ...props });
});
FormLabel.displayName = "FormLabel";
var FormControl = React2.forwardRef(
  ({ ...props }, ref) => {
    const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
    return /* @__PURE__ */ jsx(
      Slot,
      {
        ref,
        id: formItemId,
        "aria-describedby": !error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`,
        "aria-invalid": !!error,
        ...props
      }
    );
  }
);
FormControl.displayName = "FormControl";
var FormDescription = React2.forwardRef(
  ({ className, ...props }, ref) => {
    const { formDescriptionId } = useFormField();
    return /* @__PURE__ */ jsx("p", { ref, id: formDescriptionId, className: cn("text-muted-foreground text-sm", className), ...props });
  }
);
FormDescription.displayName = "FormDescription";
var FormMessage = React2.forwardRef(
  ({ className, children, ...props }, ref) => {
    const { error, formMessageId } = useFormField();
    const body = error ? String(error?.message) : children;
    if (!body) {
      return null;
    }
    return /* @__PURE__ */ jsx("p", { ref, id: formMessageId, className: cn("text-destructive text-sm", className), ...props, children: body });
  }
);
FormMessage.displayName = "FormMessage";

export { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, useFormField };
//# sourceMappingURL=chunk-2JTTMWKE.js.map
//# sourceMappingURL=chunk-2JTTMWKE.js.map